module.exports = __webpack_public_path__ + "media/2.5a0caf48.mp4";